export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api/v1',
  serverIp: import.meta.env.VITE_MINECRAFT_SERVER_IP ?? 'play.blastcore.it',
  avatarBaseUrl:
    import.meta.env.VITE_AVATAR_BASE_URL ?? 'https://mc-heads.net/avatar',
  bodyRenderBaseUrl:
    import.meta.env.VITE_BODY_RENDER_BASE_URL ?? 'https://mc-heads.net/body',
} as const
